class PromotionStorage {
    constructor() {
      this.LOCAL_STORAGE_PROMOTION = "promotion-detail";
      this.LOCAL_STORAGE_REWARD_POINT = "promotion-reward-point";
      this.LOCAL_STORAGE_REDEEMING = "redeeming-addfriend";
    }
  
    get promotionDetail() {
      return JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_PROMOTION));
    }
    set promotionDetail(data) {
      localStorage.setItem(this.LOCAL_STORAGE_PROMOTION, JSON.stringify(data));
    }
    clearPromotionDetail() {
        localStorage.removeItem(this.LOCAL_STORAGE_PROMOTION)
    }

    get promotionRewardPoint() {
        return JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_REWARD_POINT));
    }
    set promotionRewardPoint(data) {
        localStorage.setItem(this.LOCAL_STORAGE_REWARD_POINT, JSON.stringify(data));
    }
    clearPromotionRewardPoint() {
        localStorage.removeItem(this.LOCAL_STORAGE_REWARD_POINT)
    }

    get redeemingAddFriend() {
      return JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_REDEEMING));
    }
    set redeemingAddFriend(data) {
        localStorage.setItem(this.LOCAL_STORAGE_REDEEMING, JSON.stringify(data));
    }
    clearRedeemingAddFriend() {
        localStorage.removeItem(this.LOCAL_STORAGE_REDEEMING)
    }
  }
  
  export default new PromotionStorage();